import { ReactNode } from 'react';

import { Box, SxProps, Typography, useMediaQuery } from '@mui/material';

import rightArrow from '../../../assets/icons/rightArrow.png';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import { IconWrapper } from '../../elements/IconWrapper/Index';
import ImageWrapper from '../../elements/ImageWrapper';
import { theme } from '../../../theme/themeProvider';

const styles: IStyles = {
  card: {
    cursor: 'pointer',
    width: { xs: '100%', md: pxTovW(425) },
    height: '100%',
    padding: { md: pxTovW(10) },
    paddingY: { xs: pxToRem(10), md: pxTovW(10) },
    boxSizing: 'border-box',
    // backgroundColor: 'red',
    // margin: {
    //   xs: '1.5rem 1.5rem 1.5rem 1.5rem',
    //   //   md: '1.098vw 1.098vw 1.098vw 1.098vw',
    // },
    justifyContent: 'stretch',
    display: 'flex',
    border: 'none',
    // flexDirection: 'column',
    '&:hover': {
      boxShadow: { md: `0px 0px ${pxToRem(11)} #E7E7E7D9` },
    },
  },

  iconTextBoxContainer: {
    width: '100%',
    display: 'flex',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    alignItems: 'center',
  },
};

interface IconDetails {
  iconName: string;
  text: string;
}
interface IProps {
  variant: 'normal' | 'ongoing';
  cardClickHandler?: () => void;
  image?: string;
  mainHeading: string;
  headingFullWidth?: boolean;
  blueSubText?: string;
  withArrow?: boolean;
  rootStyle?: SxProps;
  status?: ReactNode;
  iconDetails?: IconDetails[];
  defaultImage?: string;
  offineSubText?: string;
  children?: ReactNode;
  isLocked?: boolean;
  itemDetails?: { iconName: string; text?: string };
}

export const ChapterCard = (props: IProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const isIpadOnly = !isMobile && isIpad;
  const {
    variant,
    cardClickHandler,
    image,
    mainHeading,
    headingFullWidth,
    blueSubText,
    withArrow,
    rootStyle,
    status,
    iconDetails,
    defaultImage,
    offineSubText,
    children,
    isLocked,
    itemDetails,
  } = props;
  let rootSx = { ...styles.card };
  if (variant === 'ongoing')
    rootSx = { ...rootSx, border: '1px solid #38FF92' };
  if (rootStyle) rootSx = { ...rootSx, ...rootStyle };
  return (
    <Box
      onClick={cardClickHandler}
      sx={{
        ...rootSx,
        flexDirection: 'column',
        position: 'relative',
        opacity: isLocked ? 0.5 : 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: pxToRem(10),
          alignItems: 'center',
          // marginLeft: { xs: pxToRem(20) },
        }}
      >
        {/* <img
          alt="chapter"
          src={TopicImage1}
          style={{ height: '6rem', width: '6rem' }}
        /> */}
        <ImageWrapper
          name={defaultImage ? defaultImage : 'chapterImage'}
          type="png"
          parentFolder={defaultImage ? 'icons' : 'tempAssets'}
          styles={{
            height: { xs: pxToRem(68), md: pxTovW(121) },
            width: { xs: pxToRem(68), md: pxTovW(121) },
            objectFit: 'cover',
            borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
          }}
          path={image}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            // backgroundColor: 'blue',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              height: '100%',
              gap: { xs: pxToRem(5), md: pxTovW(10) },
              flexDirection: 'column',
              // backgroundColor: 'red',
              // justifyContent: 'flex-start',
              // justifyContent: 'space-between',
              justifyContent: status || iconDetails ? 'space-around' : 'center',
              alignItems: 'flex-start',
              marginRight: {
                xs: children ? pxToRem(45) : 0,
                md: 0,
              },
            }}
          >
            <Typography
              variant="h4"
              fontWeight="bold"
              sx={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                width: {
                  xs: pxToRem(150),
                  md: headingFullWidth ? 'unset' : pxTovW(150),
                },
                wordBreak: 'break-word',
              }}
            >
              {mainHeading}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'row', md: 'column' },
                gap: { xs: pxToRem(15), md: pxTovW(10) },
              }}
            >
              {blueSubText && (
                <Typography variant={isIpadOnly ? 'h4' : 'h5'} color="#007CDC">
                  {blueSubText}
                </Typography>
              )}
              {itemDetails && (
                <Box
                  sx={{
                    display: 'flex',
                    gap: { xs: pxToRem(5), md: pxTovW(5) },
                    alignItems: 'center',
                  }}
                >
                  <IconWrapper
                    name={itemDetails.iconName}
                    size={isIpadOnly ? 'md' : 'small'}
                    parentFolder="icons"
                    type="png"
                  />
                  <Typography variant="h5" fontWeight="regular">
                    {itemDetails.text}
                  </Typography>
                </Box>
              )}
            </Box>

            {offineSubText && (
              <Typography variant="h5" fontWeight="regular" color="#333333">
                {offineSubText}
              </Typography>
            )}

            {status ? (
              status
            ) : (
              <Box>
                {iconDetails && (
                  <Box sx={styles.iconTextBoxContainer}>
                    {iconDetails.map((elem, index) => (
                      <IconTextBox
                        key={index}
                        iconName={elem.iconName}
                        text={elem.text}
                        index={index}
                      />
                    ))}
                  </Box>
                )}
              </Box>
            )}
          </Box>

          {withArrow && (
            <img
              alt="chapter"
              src={rightArrow}
              style={{
                height: pxToRem(12.5),
                width: pxToRem(7),
                marginRight: pxToRem(12.5),
              }}
            />
          )}
          {/* <ImageWrapper
            name="rightArrow"
            type="png"
            parentFolder="icons"
            styles={{ height: '1rem', width: '0.5rem', marginRight: '1.25rem' }}
          ></ImageWrapper> */}
        </Box>
      </Box>
      {children}
    </Box>
  );
};

interface IBox {
  iconName: string;
  text?: string;
  index?: number;
}
const IconTextBox = ({ iconName, text, index }: IBox) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const isIpadOnly = !isMobile && isIpad;
  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: pxToRem(4), md: pxTovW(4) },
        alignItems: 'center',
      }}
    >
      <IconWrapper
        name={iconName}
        size={isIpadOnly ? 'md' : 'small'}
        parentFolder="icons"
        type="png"
      />
      {text && (
        <Typography
          variant="smallText"
          fontWeight={'bold'}
          color={index === 0 ? 'primary' : 'initial'}
        >
          {text}
        </Typography>
      )}
    </Box>
  );
};
